<template>
  <!-- Hero -->
  <section class="hero" aria-labelledby="page-title">
    <div class="section__inner hero__inner">
      <h2 id="page-title">국제내부통제경영인증</h2>
      <p><strong>ICI Korea </strong> Recognizing Competency World-Wide</p>
    </div>
  </section>

  <main class="result-page" aria-labelledby="result-title">
    <!-- Title -->
    <!-- <header class="page-head">
      <h1 id="result-title" class="title">자가 진단 결과 요약</h1>
      <p class="desc">제출한 응답을 바탕으로 산출된 결과입니다.</p>
    </header> -->

    <!-- 로딩 / 에러 -->
    <section v-if="loading" class="section">
      <p class="desc">결과를 준비하고 있어요…</p>
    </section>

    <section v-else-if="error" class="section">
      <p class="desc" style="color:#b91c1c">{{ error }}</p>
    </section>

    <!-- 실제 결과 영역 -->
    <template v-else>
      <!-- ===== 중점 항목별 요약 (섹션 평균, 3색 스케일) ===== -->
      <section class="focus-summary card" aria-labelledby="fs-title">
        <h2 id="fs-title" class="card__title">핵심 요약</h2>
        <p class="desc">
          조직의 <strong>지배구조(Corporate Governance)</strong> 수준은 다음 기준에 따라 평가 점수를 확인할 수 있습니다.
        </p>

        <p class="desc">
          🔴 <strong>빨강 (Red)</strong>: 해당 영역 또는 요인은 <strong>통제 및 지배구조 리스크를 수용 가능한 수준으로 낮추기 위해 상당한 보완과 개선이 필요한 상태</strong>를 의미합니다.
        </p>

        <p class="desc">
          🟡 <strong>노랑 (Yellow)</strong>: 해당 영역 또는 요인은 <strong>일정 부분의 보완과 개선이 필요하며, 강화되지 않을 경우 리스크 수준이 상승할 수 있는 상태</strong>를 의미합니다.
        </p>

        <p class="desc">
          🟢 <strong>초록 (Green)</strong>: 해당 영역 또는 요인은 <strong>충분히 효과적으로 운영되고 있으며, 통제 및 지배구조 리스크가 수용 가능한 최소 수준으로 유지되고 있는 상태</strong>를 의미합니다.
        </p>


        <div class="fs-table">
          <div class="fs-thead">
            <div class="fs-th">중점 항목</div>
            <div class="fs-th fs-th--score">평균</div>
          </div>

          <div class="fs-tbody">
            <div v-for="row in sectionStats" :key="row.sectionId" class="fs-tr">
              <div class="fs-td fs-td--label">
                <span class="fs-label-title">{{ row.sectionTitle }}</span>
                <span class="fs-label-goal">{{ row.sectionGoal }}</span>
              </div>

              <!-- 3색 스케일 + 포인터 -->
              <div class="fs-td fs-td--scale">
                <div class="fs-scale" :style="{ '--score-pos': scorePosRYG(row.avg) }">
                  <div class="fs-scale__bar" aria-hidden="true">
                    <span class="fs-seg fs-seg--1"></span>
                    <span class="fs-seg fs-seg--2"></span>
                    <span class="fs-seg fs-seg--3"></span>
                    <span class="fs-seg fs-seg--4"></span>
                    <span class="fs-seg fs-seg--5"></span>
                  </div>
                  <div class="fs-scale__pointer" role="img" aria-label="섹션 평균 점수 위치"></div>
                </div>
                <div class="fs-scale__legend"></div>
                <p class="desc" style="margin-top:6px;">
                  <!-- 평균: {{ row.avg.toFixed(2) }} -->
                   체크한 항목 : {{ row.count }}개
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- ===== 전체 요약 (백분율) ===== -->
      <section class="score-summary">
        <div class="score-grid">
          <div class="score-label">점수</div>
          <div class="score-value">{{ overallPct.toFixed(1) }}점</div>
        </div>
      </section>

      <!-- 결과 테이블(3열 GRID) -->
      <section v-if="snapshot && snapshot.items?.length" class="matrix" aria-label="결과 테이블">
        <div class="matrix__head">
          <div class="cell cell--head">구분</div>
          <div class="cell cell--head">종합 평가</div>
          <div class="cell cell--head">실행 계획</div>
        </div>

        <!-- ✅ 해당 점수 구간만 한 줄 출력 -->
        <div v-for="row in activeRows" :key="row.id" class="matrix__row">
          <div class="cell cell--range">
            <strong>{{ row.rangeLabel }}</strong>
          </div>
          <div class="cell">
            <p class="p" v-for="(line, i) in row.eval" :key="i">
              {{ line }}
            </p>
          </div>
          <div class="cell">
            <p class="p" v-for="(line, i) in row.plan" :key="i">
              {{ line }}
            </p>
          </div>
        </div>
      </section>



      <!-- ===== 점수별 분석 (1=빨강, 2=노랑, 3=초록) ===== -->
      <!-- <section class="grouped card" aria-labelledby="grp-title">
        <h2 id="grp-title" class="card__title">영역별 고려사항</h2>

        <div>
          이 항목은 평가 결과를 점수(색상 등급)에 따라 구분하여, 조직의 각
          영역이 어느 수준의 성숙도를 보이는지 요약·분석하는 부분입니다.
        </div>

        <div class="grid">
          <section v-for="n in [1, 2, 3]" :key="n" class="bucket" :data-score="n">
            <h3 class="bucket__title" :data-score="n">
              <span class="bucket__color" :class="{
                'bucket__color--red': n === 1,
                'bucket__color--yellow': n === 2,
                'bucket__color--green': n === 3
              }"></span>

              <span class="bucket__label">
                <template v-if="n === 1">
                  통제 및 지배구조 리스크를 수용 가능한 수준으로 낮추기 위해
                  상당한 보완과 개선이 필요한 영역
                </template>
                <template v-else-if="n === 2">
                  일정 부분의 보완과 개선이 필요하여, 강화되지 않을 경우
                  리스크 수준이 상승할 수 있는 영역
                </template>
                <template v-else>
                  충분히 효과적으로 운영되고 있으며, 통제 및 지배구조
                  리스크가 수용 가능한 최소 수준으로 유지되고 있는 영역
                </template>
              </span>
            </h3>

            <ul class="bucket__list">
              <li
                v-for="(group, gi) in scoreBucketsGrouped[n]"
                :key="gi"
                class="item item--group"
              >
                <strong class="item__section">[{{ group.sectionTitle }}]</strong>

                <ul class="item__inner">
                  <li
                    v-for="(q, qi) in group.items"
                    :key="qi"
                    class="item__q"
                  >
                    {{ q }}
                  </li>
                </ul>
              </li>

              <li v-if="!scoreBucketsGrouped[n]?.length" class="item">
                해당 항목 없음
              </li>
            </ul>

          </section>
        </div>
      </section> -->

      <!-- <section class="grouped card" aria-labelledby="grp-title">
        <h2 id="grp-title" class="card__title">영역별 미흡사항</h2>

        <div>
          이 항목은 평가 결과를 점수(색상 등급)에 따라 구분하여, 조직의 각 영역이 어느 수준의 성숙도를 보이는지를 요약·분석하는 부분입니다.
        </div>

        <div class="grid">
          <section v-for="n in [0]" :key="n" class="bucket" :data-score="n">
              <h3 class="bucket__title" :data-score="n">
                <span
                  class="bucket__color bucket__color--no"
                ></span>

                <span class="bucket__label">
                  통제 및 지배구조 리스크를 수용 가능한 수준으로 낮추기 위해 상당한 보완과 개선이 필요한 영역 
                </span>
              </h3>

              <ul class="bucket__list">
                <li
                  v-for="(group, gi) in yesNoBucketsGrouped[0]"
                  :key="gi"
                  class="item item--group"
                >
                  <strong class="item__section">[{{ group.sectionTitle }}]</strong>

                  <ul class="item__inner">
                    <li
                      v-for="(q, qi) in group.items"
                      :key="qi"
                      class="item__q"
                    >
                      {{ q }}
                    </li>
                  </ul>
                </li>

                <li v-if="!yesNoBucketsGrouped[0]?.length" class="item">
                  해당 항목 없음
                </li>
              </ul>
            </section>
          </div>
      </section> -->
      <section class="grouped card" aria-labelledby="grp-title">
        <h2 id="grp-title" class="card__title">영역별 미흡사항</h2>

        <div>
          이 항목은 각 영역의 점수(색상 등급)에 따라 구간을 나누고,
          각 구간별로 <strong>No(개선 필요)</strong>로 응답된 질문만 모아 보여주는 요약입니다.
        </div>

        <div class="grid">
          <!-- 1) 0~39% : 빨강/주황 구간 -->
          <section class="bucket bucket--low">
            <h3 class="bucket__title">
              <span class="bucket__color bucket__color--low"></span>
              <span class="bucket__label">
                <strong>통제 및 지배구조 리스크를 수용 가능한 수준으로 낮추기 위해 상당한 보완과 개선이 필요한 영역 </strong>
              </span>
            </h3>

            <ul class="bucket__list">
              <li
                v-for="group in riskBuckets.low"
                :key="group.sectionId"
                class="item item--group"
              >
                <strong class="item__section">
                  <!-- [{{ group.sectionTitle }}] ({{ group.scorePct.toFixed(1) }}%) -->
                  [{{ group.sectionTitle }}]
                </strong>

                <ul class="item__inner">
                  <li
                    v-for="(q, qi) in group.items"
                    :key="qi"
                    class="item__q"
                  >
                    {{ q }}
                  </li>
                </ul>
              </li>

              <li v-if="!riskBuckets.low.length" class="item">
                해당 구간에 No로 응답된 항목이 없습니다.
              </li>
            </ul>
          </section>

          <!-- 2) 40~79% : 노랑/연두 구간 -->
          <section class="bucket bucket--mid">
            <h3 class="bucket__title">
              <span class="bucket__color bucket__color--mid"></span>
              <span class="bucket__label">
                <strong>일정 부분의 보완과 개선이 필요하여, 강화되지 않을 경우 리스크 수준이 상승할 수 있는 영역 </strong>
              </span>
            </h3>

            <ul class="bucket__list">
              <li
                v-for="group in riskBuckets.mid"
                :key="group.sectionId"
                class="item item--group"
              >
                <strong class="item__section">
                  [{{ group.sectionTitle }}]
                </strong>

                <ul class="item__inner">
                  <li
                    v-for="(q, qi) in group.items"
                    :key="qi"
                    class="item__q"
                  >
                    {{ q }}
                  </li>
                </ul>
              </li>

              <li v-if="!riskBuckets.mid.length" class="item">
                해당 구간에 No로 응답된 항목이 없습니다.
              </li>
            </ul>
          </section>

          <!-- 3) 80% 이상 : 초록 구간 -->
          <section class="bucket bucket--high">
            <h3 class="bucket__title">
              <span class="bucket__color bucket__color--high"></span>
              <span class="bucket__label">
                <strong>충분히 효과적으로 운영되고 있으며, 통제 및 지배구조 리스크가 수용 가능한 최소 수준으로 유지되고 있는  영역</strong>
              </span>
            </h3>

            <ul class="bucket__list">
              <li
                v-for="group in riskBuckets.high"
                :key="group.sectionId"
                class="item item--group"
              >
                <strong class="item__section">
                  [{{ group.sectionTitle }}]
                </strong>

                <ul class="item__inner">
                  <li
                    v-for="(q, qi) in group.items"
                    :key="qi"
                    class="item__q"
                  >
                    {{ q }}
                  </li>
                </ul>
              </li>

              <li v-if="!riskBuckets.high.length" class="item">
                해당 구간에 No로 응답된 항목이 없습니다.
              </li>
            </ul>
          </section>
        </div>
      </section>



      <!-- ===== 기준별 상세 표 (선택값을 설문 양식(RYG) 그대로 표시) ===== -->
      <h2 id="grp-title" class="card__title">진단표 응답 내역</h2>

      <section v-for="(sec, si) in sections" :key="sec.key" class="audit-section" :aria-labelledby="`sec-title-${si}`">

        <h2 :id="`sec-title-${si}`" class="ag-title">
          {{ sec.title }}
        </h2>
        <p class="ag-goal" v-if="sec.goal">목표: {{ sec.goal }}</p>

        <div class="ag-table" role="table" :aria-label="`${sec.title} 설문 표`">
          <!-- Head -->
          <div class="ag-thead" role="row">
            <div class="ag-th ag-th--no" role="columnheader">구분</div>
            <div class="ag-th ag-th--q" role="columnheader">질문항목</div>
            <div class="ag-th ag-th--score" role="columnheader">응답</div>
            <div class="ag-th ag-th--note" role="columnheader">비고</div>
          </div>

          <!-- Body -->
          <ul class="ag-tbody">
            
            <li v-for="(q, qi) in sec.items" :key="q.questionCode || q.key || qi" class="ag-tr" role="row">
              <div class="ag-td ag-td--no" role="cell">{{ qi + 1 }}</div>

              <div class="ag-td ag-td--q" role="cell">
                <label class="ag-q">{{ q.queItem || q.text }}</label>
              </div>

              <!-- 읽기전용 RYG 라디오 표시 -->
              <!-- <div class="ag-td2 td--score" role="cell">
                <fieldset class="score-ryg" :aria-labelledby="`res-${si}-${qi}-label`">
                  <legend :id="`res-${si}-${qi}-label`" class="sr-only">
                    문항 색상 선택
                  </legend>

                  <label class="ryg">
                    <input type="radio" :name="`res-${si}-${qi}`" :id="`res-${si}-${qi}-r`" value="1"
                      :checked="Number(q.score) === 1" disabled />
                    <span class="ryg__btn ryg__btn--red" aria-label="빨강(미흡)"></span>
                  </label>

                  <label class="ryg">
                    <input type="radio" :name="`res-${si}-${qi}`" :id="`res-${si}-${qi}-y`" value="2"
                      :checked="Number(q.score) === 2" disabled />
                    <span class="ryg__btn ryg__btn--yellow" aria-label="노랑(보통)"></span>
                  </label>

                  <label class="ryg">
                    <input type="radio" :name="`res-${si}-${qi}`" :id="`res-${si}-${qi}-g`" value="3"
                      :checked="Number(q.score) === 3" disabled />
                    <span class="ryg__btn ryg__btn--green" aria-label="초록(우수)"></span>
                  </label>
                </fieldset>
              </div> -->

              <div class="ag-td2 td--score" role="cell">
                <span
                  class="yn-result"
                  :class="{
                    'yn-result--yes': q.score === 1,
                    'yn-result--no': q.score === 0
                  }"
                >
                  <template v-if="q.score === 1">Yes</template>
                  <template v-else-if="q.score === 0">No</template>
                  <template v-else>미응답</template>
                </span>
              </div>


              <div class="ag-td2 ag-td--note" role="cell">
                {{ q.note || '-' }}
              </div>
            </li>
          </ul>
        </div>
      </section>

      <div class="upgrade-note">
        <p>
          보다 정밀한 진단과 맞춤 실행계획 컨설팅이 필요하신가요?
        </p>
        <p>
          <strong style="font-weight: 700;">한국내부통제협회 회원</strong>으로 전환하여
          정량평가 · 인증 프로그램을 이용해 보세요.
        </p>
      </div>


      <!-- 컨설팅 안내 -->
      <div class="consulting-note">
        <p>
          본 자가진단 결과는 조직의 내부통제 성숙도 수준을 파악하기 위한
          <strong>1차 평가 자료</strong>로 활용됩니다.
        </p>

        <p>
          미흡하거나 개선이 필요한 항목에 대해서는 한국내부통제협회의
          <strong>「국제 내부통제경영인증 컨설팅」</strong>을 통해 체계적인
          개선 및 국제 인증 절차를 진행할 수 있습니다.
        </p>

        <p>
          별도 컨설팅을 원하시는 경우, 한국내부통제협회 담당자에게
          문의하시면 내부통제 체계 고도화 및 국제 인증 절차에 대한 상세
          안내를 받으실 수 있습니다.
        </p>

        <p class="contact">
          ▸ <strong>컨설팅 문의: 070-4489-7447</strong>
        </p>
      </div>


    </template>
  </main>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { selectFreeSurveyList } from '@/api/survey'

/** ===== 스냅샷 키(기존 무료 설문 구조 유지) ===== */
const SNAP_KEY = 'free-survey-snapshot'

const router = useRouter()
const store = useStore()

const loading = ref(true)
const error = ref('')
const snapshot = ref(null)

const userInfo = computed(() => store.state.temp?.userInfo || null)
const isLoggedIn = computed(
  () => !!(userInfo.value?.userId || userInfo.value?.authToken)
)

/** ===== 설문 메타 (무료 설문용 라벨만 사용) ===== */
const SURVEY_META = {
  FREE: {
    label: '자가 진단',
    criteria: {
      '1': {
        // 영역별 고려사항 / 점검표 응답 내역에서 쓸 라벨
        title: '감사위원회(Audit Committee)',
        // 🔹 핵심 요약(위)에서 쓸 질문항목 텍스트
        focusTitle: '감사위원회',
        focusGoal: '독립성 및 보고 체계, 운영 및 평가, 내부통제 감독 기능',
      },
      '2': {
        title: '내부감사인(Internal Auditors)',
        focusTitle: '내부감사인',
        focusGoal: '역할 및 범위, 보고 및 독립성, 내부통제 및 조직문화',
      },
      '3': {
        title: '외부감사인(Independent Auditors)',
        focusTitle: '외부감사인',
        focusGoal: '감사 독립성, 감사절차 및 협업, 내부통제 관련 감독',
      },
      '4': {
        title: '최고 경영진(Executive Management)',
        focusTitle: '최고경영진',
        focusGoal: '윤리 및 준법경영, 성과 및 전략 관리, 내부통제 및 리스크 관리',
      },
      '5': {
        title: '이사회(Board of Directors)',
        focusTitle: '이사회',
        focusGoal: '구성 및 역할, 운영 및 감독절차, 내부통제 및 평가체계',
      },
    },
  },
}


/* =========================
 * 구간 문구 (그대로)
 * ========================= */
const rows = [
  {
    id: 'r1',
    min: 0,
    max: 24,
    rangeLabel: '총점이 0% ~ 24%인 경우',
    eval: [
      '결과는 조직 전반에서 내부통제 절차와 기업지배구조 관행이 거의 존재하지 않음을 보여줍니다.',
      '조직은 직원 교육 프로그램을 대대적으로 시행하고, 국제공인 내부통제 전문가(CICS: Certified Internal Control Specialist, CICP: Certified Internal Control Professional) 등의 인증된 전문가의 도움을 받아 개선 프로그램을 추진해야 합니다.'
    ],
    plan: [
      '조직에는 공식적인 내부통제 및 지배구조 프로그램이 없거나, 비효율적으로 운영되고 있을 가능성이 높습니다.',
      '이것은 조직 전체의 과제로서, 모든 이해관계자의 참여와 교육이 필수적입니다.',
      '또한, 내부통제 및 거버넌스 관련 법규를 충족해야 하므로 교육과 소통이 매우 중요합니다.',
      '기본적인 내부통제 원칙과 개념에 대한 지식을 제공하는 자료로는 다음을 추천합니다:',
      '- 온라인 내부통제 교육(Online Internal Control Training)',
      '- 내부통제 백과사전(Encyclopedia of Internal Controls - Control Descriptions)',
      '- 내부통제 공통 지식체계(Internal Control Common Body of Knowledge)',
      '또한, 가능한 많은 이해관계자들이 CICS/CICP 인증 프로그램을 통해 자격을 취득하거나 인증된 전문가의 도움을 받도록 장려해야 합니다. 이러한 인적 투자는 장기적으로 기업에 큰 이익을 가져올 것입니다.'
    ]
  },
  {
    id: 'r2',
    min: 25,
    max: 50,
    rangeLabel: '총점이 25% ~ 50%인 경우',
    eval: [
      '결과는 조직이 평균적이거나 다소 평균 이하 수준의 내부통제 및 기업지배구조 관행을 가지고 있음을 나타냅니다.'
    ],
    plan: [
      '조직은 내부감사 활동을 통해 식별된 일반적인 통제 문제를 방지하기 위한 일부 통제 절차를 구축한 것으로 보입니다. 주로 감사 시스템 개선과 감사보고서를 통한 사후적 조치에 집중했을 가능성이 큽니다.',
      '그러나 이는 반응적(reactive) 접근 방식이며, 보다 선제적(proactive) 접근이 장기적으로 훨씬 효과적입니다.',
      '선제적 내부통제 프로그램은 모든 직원을 참여시키며, 다음과 같은 도구들이 도움이 됩니다:',
      '- 정량적 평가(Quantitative Assessment) 를 통한 현재 내부통제 및 거버넌스 수준 진단',
      '- 온라인 내부통제 교육(On-line Internal Control Training)',
      '- 직원 인증 프로그램(Certification Programs)',
      '이러한 도구들을 활용하여 장기적이고 지속 가능한 내부통제 개선 프로그램을 개발할 수 있습니다.'
    ]
  },
  {
    id: 'r3',
    min: 51,
    max: 76,
    rangeLabel: '총점이 51% ~ 76%인 경우',
    eval: [
      '조직은 전 세계 평균 이상 수준의 생산적인 내부통제 실무를 수행하고 있습니다.',
      '일부 개선 이니셔티브를 실행한다면, 세계적 수준(world-class) 으로 발전할 가능성이 높습니다.'
    ],
    plan: [
      '현재 내부감사를 기반으로 한 여러 통제 절차가 존재하나, 여전히 반응적 접근 방식에 치우쳐 있을 수 있습니다.',
      '따라서 전사적 차원의 선제적 내부통제 프로그램이 필요합니다.',
      '활용 가능한 도구:',
      '- 정량적 평가(Quantitative Assessment) : 세계적 기준(World-Class Guidelines)에 따른 내부통제 및 거버넌스 수준 평가',
      '- 온라인 내부통제 교육 및 인증 프로그램',
      '조직은 이미 세계적 수준에 근접한 상태이며, COSO 모델 기반 조직 정량 평가(Quantitative Rating Based on the Use of the COSO Model) 나 세계적 기준 대비 정량 평가(Quantitative Assessment against World-Class Guidelines) 를 수행함으로써 추가 개선이 필요한 영역을 식별할 수 있습니다.',
      '이는 어려운 과제라기보다, 검증된 우수사례(Best Practices) 를 적용함으로써 충분히 개선할 수 있습니다.',
      '핵심은 빠른 개선이 가능한 영역을 식별하는 것입니다.'
    ]
  },
  {
    id: 'r4',
    min: 80,
    max: 100,
    rangeLabel: '총점이 80% 이상인 경우',
    eval: [
      '결과는 귀사의 조직이 내부통제 및 기업지배구조 분야에서 세계적 수준(World-Class) 에 있음을 나타냅니다.'
    ],
    plan: [
      '귀사는 내부통제 및 거버넌스 활동에서 매우 탁월하고 모범적인 조직입니다.',
      '만약 각 통제 항목에서 대부분의 점수가 5점 이상이라면, 귀사는 전 세계 상위 95번째 백분위(Top 95th percentile) 에 속합니다.',
      '조직 전반에 탁월한 프로세스와 실무가 잘 정착되어 있으며, 모범이 될 만한 수준의 성과를 보이고 있습니다.',
      '다만, 5점 미만인 항목은 추가 개선을 통해 효율성을 높일 수 있습니다.'
    ]
  }
]



// ✅ 전체 백분율(overallPct)로 현재 구간 찾기
const activeRow = computed(() => {
  const p = overallPct.value          // ⬅️ 새로 만든 0~100 점수
  if (!p && p !== 0) return null
  return rows.find(r => p >= r.min && p <= r.max) || null
})

// ✅ 템플릿 v-for용 배열 (한 줄만 돌리기)
const activeRows = computed(() =>
  activeRow.value ? [activeRow.value] : []
)


const ACTIVE_META = computed(() => SURVEY_META.FREE)
const CRITERIA_META = computed(() => ACTIVE_META.value.criteria || {})

/** raw item 배열 (snapshot 기반) */
const items = computed(() =>
  Array.isArray(snapshot.value?.items) ? snapshot.value.items : []
)

/** 섹션 메타 (CRITERIA_META → 없으면 데이터에서 유추) */
function sectionMeta(sectionId) {
  const sid = String(sectionId ?? '')
  const byMeta = CRITERIA_META.value[sid]
  if (byMeta) return byMeta

  const found = items.value.find(
    (it) => String(it.sectionId ?? '') === sid
  )

  return {
    title: found?.sectionTitle || `기준 ${sid}`,
    goal: found?.sectionGoal || '',
  }
}

/** 1~3 평균을 0~100%로 (1→0, 3→100) */
// function scorePosRYG(avg) {
//   if (!avg || Number.isNaN(avg)) return '0%'
//   const pct = ((avg - 1) / 2) * 100
//   const clamp = Math.max(0, Math.min(100, pct))
//   return `${clamp.toFixed(2)}%`
// }

/** 0~1 비율을 0~100%로 (0→0, 1→100) */
function scorePosRYG(avg) {
  if (avg == null || Number.isNaN(avg)) return '0%'
  const ratio = Math.max(0, Math.min(1, avg)) // 0~1로 클램핑
  return `${(ratio * 100).toFixed(2)}%`
}


/** ===== 섹션별 평균(1~3만 포함) ===== */
// const sectionStats = computed(() => {
//   const map = new Map()

//   for (const it of items.value) {
//     const sid = String(it.sectionId ?? '')
//     if (!map.has(sid)) {
//       map.set(sid, { sectionId: sid, sum: 0, count: 0 })
//     }
//     const row = map.get(sid)
//     const sc = Number(it.score ?? 0)
//     if (sc >= 1 && sc <= 3) {
//       row.sum += sc
//       row.count += 1
//     }
//   }

//   return [...map.entries()]
//     .sort((a, b) => Number(a[0]) - Number(b[0]))
//     .map(([sid, r]) => {
//       const meta = sectionMeta(sid)
//       const avg = r.count ? r.sum / r.count : 0

//       // 🔹 핵심 요약 전용 라벨(없으면 기존 title/goal 사용)
//       const titleForFocus = meta.focusTitle || meta.title
//       const goalForFocus =
//         meta.focusGoal || meta.goal || ''

//       return {
//         sectionId: sid,
//         sectionTitle: titleForFocus,
//         sectionGoal: goalForFocus,
//         avg,
//         count: r.count,
//       }
//     })
// })

/** ===== 섹션별 Yes 비율(0~1) ===== */
// const sectionStats = computed(() => {
//   const map = new Map()

//   for (const it of items.value) {
//     const sid = String(it.sectionId ?? '')
//     if (!map.has(sid)) {
//       map.set(sid, { sectionId: sid, yes: 0, total: 0 })
//     }
//     const row = map.get(sid)
//     const sc = Number(it.score)

//     // 0 또는 1만 유효 응답으로 사용
//     if (sc === 0 || sc === 1) {
//       row.total += 1
//       if (sc === 1) row.yes += 1
//     }
//   }

//   return [...map.entries()]
//     .sort((a, b) => Number(a[0]) - Number(b[0]))
//     .map(([sid, r]) => {
//       const meta = sectionMeta(sid)
//       const ratio = r.total ? r.yes / r.total : 0  // 0~1

//       const titleForFocus = meta.focusTitle || meta.title
//       const goalForFocus = meta.focusGoal || meta.goal || ''

//       return {
//         sectionId: sid,
//         sectionTitle: titleForFocus,
//         sectionGoal: goalForFocus,
//         avg: ratio,   // ✅ 비율(0~1)
//         count: r.total,
//       }
//     })
// })

const sectionStats = computed(() => {
  const map = new Map()

  for (const it of items.value) {
    const sid = String(it.sectionId ?? '')
    if (!map.has(sid)) {
      map.set(sid, { sectionId: sid, yes: 0, total: 0 })
    }
    const row = map.get(sid)
    const sc = it.score  // 이미 0,1,null 중 하나

    // 0 또는 1만 유효 응답으로 사용
    if (sc === 0 || sc === 1) {
      row.total += 1        // ✅ "체크한 항목" 개수
      if (sc === 1) row.yes += 1
    }
  }

  return [...map.entries()]
    .sort((a, b) => Number(a[0]) - Number(b[0]))
    .map(([sid, r]) => {
      const meta = sectionMeta(sid)
      const ratio = r.total ? r.yes / r.total : 0  // 0~1

      const titleForFocus = meta.focusTitle || meta.title
      const goalForFocus = meta.focusGoal || meta.goal || ''

      return {
        sectionId: sid,
        sectionTitle: titleForFocus,
        sectionGoal: goalForFocus,
        avg: ratio,   // 0~1 비율
        count: r.total,   // ✅ 진짜 "체크한 항목" 개수
      }
    })
})



/** ===== 전체 평균/백분율 ===== */
// const answeredItems = computed(() =>
//   items.value.filter((it) => [1, 2, 3].includes(Number(it.score)))
// )
// const answeredCount = computed(() => answeredItems.value.length)

// const overallAvg = computed(() => {
//   const n = answeredCount.value
//   if (!n) return 0
//   const sum = answeredItems.value.reduce(
//     (acc, it) => acc + Number(it.score),
//     0
//   )
//   return sum / n
// })

// const overallPct = computed(() => {
//   const avg = overallAvg.value
//   if (!avg) return 0
//   return ((avg - 1) / 2) * 100
// })

/** ===== 전체 평균/백분율 (Yes 비율) ===== */
// const answeredItems = computed(() =>
//   items.value.filter((it) => [0, 1].includes(Number(it.score)))
// )
// const answeredCount = computed(() => answeredItems.value.length)

// const yesCount = computed(() =>
//   answeredItems.value.filter((it) => Number(it.score) === 1).length
// )

// // 0~1 사이 비율
// const overallAvg = computed(() => {
//   const n = answeredCount.value
//   if (!n) return 0
//   return yesCount.value / n
// })

// // 0~100점(Yes 비율 %)로 표시
// const overallPct = computed(() => {
//   return overallAvg.value * 100
// })

// ✅ 응답한 것만 (0 또는 1만)
const answeredItems = computed(() =>
  items.value.filter((it) => it.score === 0 || it.score === 1)
)

const answeredCount = computed(() => answeredItems.value.length)

// ✅ Yes 개수도 같은 기준으로
const yesCount = computed(() =>
  answeredItems.value.filter((it) => it.score === 1).length
)

// // 0~1 사이 비율
// const overallAvg = computed(() => {
//   const n = answeredCount.value
//   if (!n) return 0
//   return yesCount.value / n
// })

// // 0~100점(Yes 비율 %)로 표시
// const overallPct = computed(() => {
//   return overallAvg.value * 100
// })

// 0~1 사이 비율 (미응답도 0점으로 포함해서 계산)
const overallAvg = computed(() => {
  const total = items.value.length          // ✅ 전체 문항 수 (미응답 포함)
  if (!total) return 0

  const yes = items.value.filter(
    (it) => Number(it.score) === 1
  ).length                                  // ✅ Yes만 카운트

  return yes / total                        // ✅ 미응답 + No는 0점으로 처리
})

// 0~100점(Yes 비율 %)로 표시 (그대로 사용)
const overallPct = computed(() => {
  return overallAvg.value * 100
})



const scoreColorClass = computed(() => {
  const score = overallPct.value
  if (score <= 30) return 'score--red'
  if (score < 70) return 'score--yellow'
  return 'score--green'
})

/** ===== 점수별 버킷(1~3) - 기존 ===== */
// const scoreBuckets = computed(() => {
//   const buckets = { 1: [], 2: [], 3: [] }
//   for (const it of items.value) {
//     const s = Number(it.score ?? 0)
//     if (s >= 1 && s <= 3) {
//       buckets[s].push({
//         sectionId: it.sectionId,
//         sectionTitle: sectionMeta(it.sectionId).title,
//         queItem: it.queItem || it.text,
//       })
//     }
//   }
//   return buckets
// })

/** ===== 점수별 버킷(1~3) - 섹션타이틀로 그룹핑 버전 ===== */
// const scoreBucketsGrouped = computed(() => {
//   // { 1: [ { sectionTitle, items:[...] }, ... ], 2: [...], 3: [...] }
//   const buckets = { 1: [], 2: [], 3: [] }

//   for (const it of items.value) {
//     const s = Number(it.score ?? 0)
//     if (s < 1 || s > 3) continue

//     const sectionId = String(it.sectionId ?? '')
//     const meta = sectionMeta(sectionId)
//     const title = meta.title  // 예: "외부감사인(Independent Auditors)"

//     // 점수별 버킷에서 같은 sectionTitle 그룹 찾기
//     let group = buckets[s].find(g => g.sectionTitle === title)
//     if (!group) {
//       group = {
//         sectionId,
//         sectionTitle: title,
//         items: [],
//       }
//       buckets[s].push(group)
//     }

//     // 이 섹션에 속하는 질문 추가
//     group.items.push(it.queItem || it.text)
//   }

//   return buckets
// })



/** ===== Yes / No 버킷(0,1) - 섹션 타이틀로 그룹핑 ===== */
const yesNoBucketsGrouped = computed(() => {
  // { 0: [ { sectionTitle, items:[...] }, ... ], 1: [...] }
  const buckets = { 0: [], 1: [] }

  for (const it of items.value) {
    const s = Number(it.score)
    if (s !== 0 && s !== 1) continue

    const sectionId = String(it.sectionId ?? '')
    const meta = sectionMeta(sectionId)
    const title = meta.title

    let group = buckets[s].find(g => g.sectionTitle === title)
    if (!group) {
      group = {
        sectionId,
        sectionTitle: title,
        items: [],
      }
      buckets[s].push(group)
    }

    group.items.push(it.queItem || it.text)
  }

  return buckets
})


/** ===== 섹션별 No(개선 필요) 항목만 그룹핑 ===== */
const noBucketsGrouped = computed(() => {
  // [ { sectionId, sectionTitle, items:[질문텍스트…] }, ... ]
  const groups = []

  for (const it of items.value) {
    // ✅ 진짜 No(0)만 사용, Yes(1) + 미응답(null/undefined/NaN)은 제외
    if (it.score !== 0) continue

    const sectionId = String(it.sectionId ?? '')
    const meta = sectionMeta(sectionId)
    const title = meta.title

    let group = groups.find(g => g.sectionId === sectionId)
    if (!group) {
      group = {
        sectionId,
        sectionTitle: title,
        items: [],
      }
      groups.push(group)
    }

    // 화면에 보여줄 문구(질문 텍스트)
    group.items.push(it.queItem || it.text)
  }

  return groups
})


// 섹션별 점수(0~100%) 맵
const sectionScorePctById = computed(() => {
  const map = {}
  for (const s of sectionStats.value) {
    map[s.sectionId] = (s.avg ?? 0) * 100
  }
  return map
})

/**
 * 리스크 버킷
 * - low  : 0 ~ 39%
 * - mid  : 40 ~ 79%  (40%는 중간 구간에 포함시켰어. 0~39 / 40~79 / 80+ 로 끊는 게 깔끔해서)
 * - high : 80% 이상
 * 각 버킷에는 해당 구간에 속하는 "섹션" 중에서
 * score === 0 인 질문들만 들어가도록 구성
 */
const riskBuckets = computed(() => {
  const result = {
    low: [],   // 0~39%
    mid: [],   // 40~79%
    high: []   // 80%+
  }

  const scoreMap = sectionScorePctById.value
  // const noGroups = yesNoBucketsGrouped.value[0] || []   // ⬅️ No 항목만 모여있는 기존 그룹
  const noGroups = noBucketsGrouped.value   // ⬅️ No만 모여있는 그룹

  for (const g of noGroups) {
    const pct = scoreMap[g.sectionId] ?? 0

    const groupWithScore = {
      ...g,
      scorePct: pct
    }

    if (pct <= 39) {
      result.low.push(groupWithScore)
    } else if (pct >= 80) {
      result.high.push(groupWithScore)
    } else {
      // 40 ~ 79
      result.mid.push(groupWithScore)
    }
  }

  return result
})


/** ===== 결과 상세 표: sectionId 기준 그룹핑 ===== */
const sections = computed(() => {
  const map = new Map()

  for (const it of items.value) {
    const sid = String(it.sectionId ?? '')
    if (!map.has(sid)) map.set(sid, [])
    map.get(sid).push(it)
  }

  return [...map.keys()]
    .sort((a, b) => Number(a) - Number(b))
    .map((sid) => {
      const meta = sectionMeta(sid)
      const rows = (map.get(sid) || []).slice()
      rows.sort((a, b) =>
        String(a.questionCode || '').localeCompare(
          String(b.questionCode || '')
        )
      )
      return {
        key: `sec_${sid}`,
        title: meta.title,
        goal: meta.goal,
        items: rows,
      }
    })
})

/* =========================
 * 데이터 로딩 (무료 설문 기존 로직 유지)
 * ========================= */
async function loadFromServer() {
  const res = await selectFreeSurveyList({
    userId: userInfo.value.userId, // 무료 설문은 surveyCode 없이도 OK
  })

  if (res?.result !== 'ok' || !Array.isArray(res.data)) {
    throw new Error('BAD_RESPONSE')
  }

  // snapshot.value = {
  //   items: res.data.map((r) => ({
  //     surveyCode: r.surveyCode || '',
  //     sectionId: r.sectionId,
  //     sectionTitle: r.sectionTitle || '',
  //     sectionGoal: r.sectionGoal || '',
  //     questionCode: r.questionFreeCode || r.questionCode || null,
  //     queItem: r.queItem || r.text || '',
  //     score: Number(r.score ?? 0),
  //     addInfo: r.addInfo || '',
  //     note: r.note || '',
  //   })),
  // }

snapshot.value = {
  items: res.data.map((r) => {
    const rawScore = r.score

    const parsedScore =
      rawScore === null ||
      rawScore === undefined ||
      rawScore === ''
        ? null                // ⬅️ 응답 안 한 건 null 유지
        : Number(rawScore)    // 응답한 것만 숫자로 변환

    return {
      surveyCode: r.surveyCode || '',
      sectionId: r.sectionId,
      sectionTitle: r.sectionTitle || '',
      sectionGoal: r.sectionGoal || '',
      questionCode: r.questionFreeCode || r.questionCode || null,
      queItem: r.queItem || r.text || '',
      score: parsedScore,     // ⬅️ 여기
      addInfo: r.addInfo || '',
      note: r.note || '',
    }
  }),
}

}


function loadFromLocal() {
  const raw = localStorage.getItem(SNAP_KEY)
  if (!raw) return
  try {
    const snap = JSON.parse(raw)
    snapshot.value = {
      items: Array.isArray(snap.items) ? snap.items : [],
    }
  } catch (e) {
    console.error(e)
  }
  // 게스트는 한 번 보여준 뒤 흔적 제거
  localStorage.removeItem(SNAP_KEY)
}

onMounted(async () => {
  try {
    loading.value = true

    if (isLoggedIn.value) {
      await loadFromServer()
      localStorage.removeItem(SNAP_KEY)
    } else {
      loadFromLocal()
    }

    if (!items.value.length) {
      error.value = '결과 데이터가 없습니다. 설문을 먼저 제출해 주세요.'
    }
  } catch (e) {
    console.error(e)
    error.value = '결과를 불러오지 못했습니다.'
  } finally {
    loading.value = false
  }
})
</script>

<style scoped>
/* 폰트/기본 타이포 */
:root {
  font-family: 'Noto Sans KR', sans-serif;
}

.title {
  font-size: 1.625rem;
  font-weight: 700;
}

.desc,
p {
  font-size: 0.95rem;
}

.desc strong{
  font-weight: 700;
}

/* 레이아웃 */
.result-page {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  gap: 24px;
  padding: 20px 16px 40px;
  background: #fff;
}

.page-head {
  display: grid;
  gap: 8px;
}

.section {
  padding: 8px 0;
}

/* Hero */
.hero {
  background:
    linear-gradient(rgba(13, 6, 20, 0.65), rgba(13, 6, 20, 0.65)),
    url('/src/assets/iicc-main.jpeg') center 70% / 65% no-repeat;
  color: #fff;
  margin-bottom: 20px;
}

.hero__inner {
  padding: 130px 16px;
  text-align: center;
}

.hero h2 {
  font-family: 'Noto Sans KR', sans-serif;
  font-weight: 700;
  color: #fff;
  font-size: 2.5rem;
  letter-spacing: -1px;
  line-height: 1.3;
}

.hero p {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.9);
  margin-top: 12px;
  letter-spacing: -0.3px;
  line-height: 1.6;
}

.hero p strong {
  font-size: 1.225rem;
  font-weight: 700;
}

/* 카드 공통 */
.card {
  display: grid;
  gap: 16px;
  padding: 16px;
  background: #fff;
}

.card__title {
  font-weight: 700;
  font-size: 1.625rem;
}

/* ===== 전체 요약 ===== */
.ov-grid {
  display: grid;
  gap: 16px;
  align-items: center;
  background-color: #f1f1f1;
  border-radius: 4px;
  padding: 16px;
  text-align: center;
}

.ov-score__big {
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.4;
}

.score-value.score--red {
  color: #dc2626;
}

.score-value.score--yellow {
  color: #d97706;
}

.score-value.score--green {
  color: #16a34a;
}

.ov-desc {
  font-size: 0.95rem;
  font-weight: 500;
  color: #10b981;
}

/* ===== 3색(5단계) 스케일 ===== */
.fs-scale {
  position: relative;
  display: grid;
  align-items: center;
}

.fs-scale__bar {
  display: flex;
  height: 18px;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);
}

.fs-seg {
  flex: 1;
}

/* 빨강 → 주황 → 노랑 → 연두 → 초록 */
.fs-seg--1 {
  background: #dc2626;
}

.fs-seg--2 {
  background: #f97316;
}

.fs-seg--3 {
  background: #facc15;
}

.fs-seg--4 {
  background: #84cc16;
}

.fs-seg--5 {
  background: #22c55e;
}

.fs-scale__pointer {
  position: absolute;
  left: calc(var(--score-pos, 0%));
  top: -10px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 8px solid #111;
  transform: translateX(-50%);
}

.fs-scale__legend {
  display: flex;
  justify-content: space-between;
  font-size: 0.85rem;
  color: #6b7280;
  padding: 0 2px;
}

/* ===== 중점 항목 요약 테이블 ===== */
.focus-summary .fs-table {
  display: grid;
  gap: 0;
}

.fs-thead,
.fs-tr {
  display: grid;
  grid-template-columns: 1fr 360px;
}

.fs-thead {
  background: #1d2088;
  color: #fff;
  border-radius: 10px 10px 0 0;
}

.fs-th,
.fs-td {
  padding: 12px;
  border-top: 1px solid #e5e7eb;
}

.fs-thead .fs-th {
  border-top: 0;
  font-weight: 700;
}

.fs-td--label {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
}

.fs-td--scale {
  display: grid;
  gap: 6px;
  align-items: center;
}

.fs-label-title {
  font-weight: 700;
}

.fs-label-goal {
  display: inline-block;
  font-weight: 400;
}

.fs-tbody {
  border: 1px solid #e5e7eb;
  border-radius: 14px;
}

/* ===== 영역별 고려사항(버킷) ===== */
.grouped .grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

.bucket {
  display: grid;
  gap: 0;
}

.bucket__title {
  display: grid;
  grid-template-columns: 80px 1fr;
  margin: 0;
  background: #02245c;
  color: #ffffff;
  font-size: 0.95rem;
  font-weight: 700;
}

.bucket__color {
  min-height: 44px;
}

.bucket__color--red {
  background: #dc2626;
}

.bucket__color--yellow {
  background: #facc15;
}

.bucket__color--green {
  background: #16a34a;
}

.bucket__color--no {
  background: linear-gradient(to right, #dc2626 0%, #dc2626 50%, #f97316 50%, #f97316 100%);
}


.bucket__label {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  line-height: 1.6;
}

.bucket+.bucket {
  padding-top: 6px;
}

.bucket__list {
  display: grid;
  gap: 8px;
  padding: 12px 16px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-top: none;
}

.item__section {
  font-weight: 700;
}

.item {
  font-size: 0.95rem;
  line-height: 1.6;
}

.bucket__list .item:nth-child(even) {
  /* background: #eeeeee; */
  padding: 2px 0px;
}

.bucket__list .item:nth-child(odd) {
  background: transparent;
  padding: 2px 0px;
}

/* ===== 상세 표 ===== */
.audit-section {
  display: grid;
  gap: 12px;
}

.ag-title {
  font-size: 1.25rem;
  font-weight: 700;
}

.ag-goal {
  font-size: 0.95rem;
}

.ag-table {
  display: grid;
  gap: 0;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
}

.ag-thead {
  display: grid;
  grid-template-columns: 72px 1fr 200px 250px;
  background: #0f172a;
  color: #fff;
  justify-items: center;
}

.ag-th {
  padding: 12px 12px;
  font-weight: 700;
}

.ag-tbody {
  display: grid;
  gap: 0;
}

.ag-tr {
  display: grid;
  grid-template-columns: 72px 1fr 200px 250px;
  border-top: 1px solid #e5e7eb;
  background: #fff;
}

.ag-td {
  padding: 12px;
  display: flex;
  align-items: center;
}

.ag-td2 {
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ag-td--no {
  justify-content: center;
  color: #6b7280;
}

.ag-td--q {
  align-items: flex-start;
}

.ag-q {
  line-height: 1.6;
}

/* RYG 라디오 읽기 전용 */
/* .score-ryg {
  display: grid;
  grid-auto-flow: column;
  gap: 10px;
  justify-content: center;
  align-items: center;
}

.ryg {
  display: grid;
  place-items: center;
}

.ryg input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.ryg__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 10px;
  height: 10px;
  padding: 12px;
  border-radius: 999px;
  border: 1px solid #d1d5db;
  background: #f9fafb;
  font-size: 0.95rem;
  font-weight: 700;
  user-select: none;
  cursor: not-allowed;
  transition:
    transform 0.06s ease,
    box-shadow 0.12s ease,
    background 0.12s ease,
    color 0.12s ease,
    border-color 0.12s ease;
}

.ryg__btn--red {
  background: #fee2e2;
  border-color: #fecaca;
  color: #b91c1c;
}

.ryg__btn--yellow {
  background: #fef3c7;
  border-color: #fde68a;
  color: #b45309;
}

.ryg__btn--green {
  background: #dcfce7;
  border-color: #bbf7d0;
  color: #047857;
}

.ryg input:checked+.ryg__btn--red {
  background: #ef4444;
  border-color: #ef4444;
  color: #fff;
}

.ryg input:checked+.ryg__btn--yellow {
  background: #f59e0b;
  border-color: #f59e0b;
  color: #111;
}

.ryg input:checked+.ryg__btn--green {
  background: #10b981;
  border-color: #10b981;
  color: #fff;
} */

/* 접근성 숨김 텍스트 */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* 짝수 행 배경색 */
.ag-tbody .ag-tr:nth-child(even) {
  background: #f5f5f5;
}

/* 컨설팅 안내 */
.consulting-note {
  padding: 16px 18px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  display: grid;
  gap: 8px;
  font-family: 'Noto Sans KR', sans-serif;
}

.consulting-note p {
  font-size: 0.95rem;
  line-height: 1.55;
  color: #333;
}

.consulting-note .contact {
  margin-top: 4px;
  font-weight: 700;
}

/* Yes / No 결과 뱃지 */
.yn-result {
  display: inline-flex;
  min-width: 34px;
  height: 34px;
  padding: 0 16px;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  font-size: 0.85rem;
  font-weight: 600;
  border: 1px solid #d1d5db;
  background: #f9fafb;
  color: #374151;
}

.yn-result--yes {
  /* border-color: #22c55e; */
  background: #eff6ff;
  /* color: #166534; */
}

.yn-result--no {
  /* border-color: #f97316; */
  background: #ffeded;
  /* color: #9a3412; */
}


/* 반응형 */
@media (max-width: 1200px) {

  .fs-thead,
  .fs-tr {
    grid-template-columns: 1fr 300px;
  }
}

@media (max-width: 992px) {
  .ov-grid {
    grid-template-columns: 1fr;
  }

  .fs-thead,
  .fs-tr {
    grid-template-columns: 1fr 260px;
  }

  .ag-thead,
  .ag-tr {
    grid-template-columns: 52px 1fr 200px 1fr;
  }
}

@media (max-width: 768px) {
  .fs-thead {
    display: none;
  }

  .fs-tr {
    grid-template-columns: 1fr;
  }

  .fs-th,
  .fs-td {
    border-top: 0;
    padding: 8px 0;
  }

  .ag-thead {
    display: none;
  }

  .ag-tr {
    grid-template-columns: 1fr;
    gap: 8px;
    border-top: 1px solid #e5e7eb;
    padding: 10px 12px;
  }

  .ag-td,
  .ag-td2 {
    padding: 0;
  }

  .ag-td--q {
    order: 2;
  }

  .td--score {
    order: 3;
  }

  .ag-td--note {
    order: 4;
  }
}

/* .matrix {
  display: grid;
  gap: 0;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.matrix__head,
.matrix__row {
  display: grid;
  grid-template-columns: 260px 1fr 1fr;
}

.cell {
  padding: 20px 18px;
  border-top: 1px solid #e5e7eb;
  border-left: 1px solid #e5e7eb;
  word-break: keep-all;
  overflow-wrap: anywhere;
  text-wrap: pretty;
  line-height: 1.6;
}

.matrix__head .cell {
  background: #111827;
  text-align: center;
  color: #fff;
  border-color: #111827;
  font-weight: 700;
}

.matrix__row .cell:first-child {
  border-left: none;
  background: #f3f4f6;
  font-weight: 700;
}

.matrix__head .cell:first-child {
  border-left: none;
}

.matrix__row.active {
  background: #859cce;
  opacity: 80%;
  outline: 2px solid #2563eb;
  outline-offset: -2px;
} */

/* 공통 – 기존 코드 + 폰트 설정 */
.matrix {
  display: grid;
  gap: 0;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  font-family: 'Noto Sans KR', sans-serif;
}

.matrix__head,
.matrix__row {
  display: grid;
  grid-template-columns: 260px 1fr 1fr;
}

.cell {
  padding: 20px 18px;
  border-top: 1px solid #e5e7eb;
  border-left: 1px solid #e5e7eb;
  word-break: keep-all;
  overflow-wrap: anywhere;
  /* text-wrap: pretty; */
  line-height: 1.6;
}

.matrix__head .cell {
  background: #111827;
  text-align: center;
  color: #fff;
  border-color: #111827;
  font-weight: 700;
}

.matrix__row .cell:first-child {
  border-left: none;
  background: #f3f4f6;
  font-weight: 700;
}

.matrix__head .cell:first-child {
  border-left: none;
}

.matrix__row.active {
  background: #859cce;
  opacity: 0.8;
  outline: 2px solid #2563eb;
  outline-offset: -2px;
}

/* p 태그 폰트 설정 */
.matrix .p,
.matrix p {
  font-size: 0.95rem;
  font-family: 'Noto Sans KR', sans-serif;
}

/* ---------------- 반응형 ---------------- */

/* 1024px 이하 – 첫 번째 열 조금 줄이기 */
@media (max-width: 1024px) {
  .matrix__head,
  .matrix__row {
    grid-template-columns: 200px 1fr 1fr;
  }

  .cell {
    padding: 16px 14px;
  }
}

/* 768px 이하 – 한 줄씩 세로 스택 */
@media (max-width: 768px) {
  .matrix {
    border-radius: 8px;
  }

  /* 헤더는 숨기고, 각 셀 앞에 라벨을 붙이는 방식으로 전환 */
  .matrix__head {
    display: none;
  }

  .matrix__row {
    display: block;          /* 한 행을 블록으로 */
    border-top: 1px solid #e5e7eb;
  }

  .matrix__row + .matrix__row {
    border-top: 1px solid #e5e7eb;
  }

  .matrix__row .cell {
    display: block;
    border-left: none;
    border-top: 1px solid #e5e7eb;
    padding: 14px 14px 12px;
  }

  .matrix__row .cell:first-child {
    border-top: none;
    background: #f3f4f6;
    font-weight: 700;
  }

  /* “종합 평가” 라벨 */
  .matrix__row .cell:nth-child(2)::before {
    content: '종합 평가';
    display: block;
    margin-bottom: 6px;
    font-size: 0.85rem;
    font-weight: 700;
    color: #6b7280;
  }

  /* “실행 계획” 라벨 */
  .matrix__row .cell:nth-child(3)::before {
    content: '실행 계획';
    display: block;
    margin-bottom: 6px;
    font-size: 0.85rem;
    font-weight: 700;
    color: #6b7280;
  }

  /* active 상태도 모바일에서 눈에 띄게 */
  .matrix__row.active {
    background: #e0ecff;
    outline: 2px solid #2563eb;
    outline-offset: -2px;
  }
}

/* 아주 작은 화면(예: 360px 이하) – padding 조금 더 줄이기 */
@media (max-width: 360px) {
  .matrix__row .cell {
    padding: 10px 10px 8px;
  }
}


.cell strong {
  font-weight: 700;
}

.upgrade-note {
  padding: 16px 18px;
  display: grid;
  gap: 6px;
  font-family: 'Noto Sans KR', sans-serif;
  margin-top: 12px;
  margin-bottom: 4px;
  text-align: center;
}

.upgrade-note p {
  font-size: 1.25rem;
  line-height: 1.55;
  color: #333;
}

.upgrade-note strong {
  font-weight: 700;
}


/* ===== 점수 요약 1행 2열 스타일 ===== */
.score-summary {
  max-width: 1200px;
  /* margin: 0 auto 12px auto; */
}

.score-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

/* 1열: 네이비 배경 */
.score-label {
  background: #02245c;       /* 네이비 */
  color: #ffffff;
  padding: 14px 16px;
  font-weight: 700;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 2열: 점수 */
.score-value {
  padding: 14px 16px;
  font-size: 1.125rem;
  font-weight: 700;
  color: #111;
  display: flex;
  align-items: center;
  justify-content: center;
}


/* 질문 리스트 기본 스타일 */
.item__inner {
  display: grid;
  gap: 2px;
  padding-left: 1em;
  font-weight: 400;
  font-size: 0.95rem;
}

/* 질문(item__q) 짝수행에만 옅은 회색 배경 */
.item__q:nth-child(even) {
  background: #eeeeee; /* 아주 옅은 회색 */
}

/* 홀수는 기본 */
.item__q:nth-child(odd) {
  background: transparent;
}

.bucket__color {
  min-height: 44px;
}

/* 0~39% : 빨강 → 주황 그라데이션 */
.bucket__color--low {
  background: linear-gradient(to right, #dc2626 0%, #dc2626 50%, #f97316 50%, #f97316 100%);
}

/* 40~79% : 노랑 → 연두 그라데이션 */
.bucket__color--mid {
  background: linear-gradient(to right, #facc15 0%, #facc15 50%, #84cc16 50%, #84cc16 100%);
}

/* 80% 이상 : 진한 초록 단색 */
.bucket__color--high {
  background: #16a34a;
}


</style>
